import { JSX, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import { cn } from "@/utils/cn.ts";

import { IconBack } from "../icons/main.icons";

interface AuthTitleProps {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  className?: string;
  goback?: boolean;
}

const AuthTitle = ({ title, subtitle, className, goback }: AuthTitleProps): JSX.Element => {
  const navigate = useNavigate();
  return (
    <div className={cn("space-y-3", className)}>
      <div className={cn("flex items-center justify-center", { "justify-between": goback })}>
        {goback && <IconBack onClick={() => navigate(-1)} className="h-8 w-8 cursor-pointer stroke-white p-1" />}
        <h1 className={"text-center text-3xl font-semibold"}>{title}</h1>
        {goback && <div className="w-8"></div>}
      </div>
      {subtitle && (
        <p className={"text-center text-lg leading-6 text-[#C7C6C6] max-lg:text-base max-lg:font-semibold"}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default AuthTitle;
